import { useEffect, useLayoutEffect } from 'react';
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
export default useIsomorphicLayoutEffect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js
// module id = ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js
// module chunks = main